
import {defineComponent, inject} from "vue";
import {v4 as uuid} from "uuid";
import { Store } from "modules/construction-work/src/Store";
import MaptalksMap from "modules/construction-work/src/Entity/Map/MaptalksMap";
import SwiperBigGalleryWidget from '@app/modules/widget/swiper/big-gallery';
import ModalWork from "modules/construction-work/components/modal/ModalWork.vue";
import {ConstructionWorkMap} from "modules/construction-work/src/Entity/Work/ConstructionWorkMap";
import {IncidentMap} from "modules/construction-work/src/Entity/Work/IncidentMap";

export default defineComponent({
    name: "RepairWorkMap",
    components: {
        ModalWork
    },
    data() {
        return {
            map: null as MaptalksMap|null,
            id: uuid(),
            currentItemMenu: null,
            style: {

            },
            isFullScreenMap: false,
            isShowSelectedWork: false,
        };
    },

    methods: {
        getBuildForMenu() {

            const itemsMenu = [...this.store.initData?.getCategoriesArray() ?? [], ...this.store.initData?.getGroupsArray() ?? []]
            return itemsMenu.filter(item => !!item?.count)?.sort((a, b) => b.count - a.count);
        },
        initMap() {
            const element = document.getElementById(this.id);
            const initData = (window as any).BaseApp.initData;
            this.map = new MaptalksMap(element, {
                initData,
                repairWorkForMap: this.buildRepairWorkForMap(),
                event: {
                    onSelectedElement: (ids) => {
                        this.onSelectedElement(ids);
                    },
                    onFullScreenMap: () => {
                        this.onFullScreenMap();
                    },
                },
            });

            this.map.init();
        },
        onFullScreenMap() {
            this.isFullScreenMap = !this.isFullScreenMap;
        },
        onShowSelectedWork(isShow: boolean) {
            this.isShowSelectedWork = isShow;
        },
        onSelectedElement(ids: (number | string)[]) {
            this.onShowSelectedWork(false);
            this.processSelectedIds(ids);
        },
        async processSelectedIds(ids: (number | string)[]): Promise<void> {
            const isSuccess = await this.store.fillDataForDetailCardMap(ids);
            if (isSuccess) {
                this.onShowSelectedWork(true);
            } else {
                console.log('Error');
            }
        },
        selectedItemMenu(categoryId?) {
            this.currentItemMenu = categoryId;
            this.map.updatePointMap(categoryId);
        },
        buildRepairWorkForMap(): (ConstructionWorkMap|IncidentMap)[] {
            return [...this.store?.incidentsMap ?? [], ...this.store.constructionWorksMap ?? []];
        }
    },
    async mounted() {
        this.initMap();
        this.$nextTick(function () {
            const optionsSlider = {
                allowTouchMove: true,
                slidesPerView: 'auto',
                spaceBetween: 10,
            }
            new SwiperBigGalleryWidget({options: optionsSlider}).init();
        });
    },
    setup() {
        const store = inject<Store>("store");
        return {
            store
        }
    }
})
